// @ts-nocheck
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface LoadProductCarouselCustomProductsParameter {
    carouselId: string;
    carouselType: string;
    productIds: string[];
    isShellEdit?: boolean;
    numberOfProductsToDisplay: number;
}

export interface LoadProductCarouselCustomProductsProps {
    getProductCollectionParameter: GetProductCollectionApiV2Parameter;
}

type HandlerType = Handler<LoadProductCarouselCustomProductsParameter, LoadProductCarouselCustomProductsProps>;

export const SetCustomProductsParameter: HandlerType = props => {
    const { productIds, carouselType, numberOfProductsToDisplay } = props.parameter;

    if (carouselType !== "customProducts") {
        return;
    }

    props.getProductCollectionParameter = {
        productIds,
        pageSize: numberOfProductsToDisplay,
        expand: ["images", "badges"],
        additionalExpands: ["attributes"],
    };
};

export const LoadCustomProducts: HandlerType = props => {
    const { dispatch, parameter, getProductCollectionParameter } = props;

    dispatch(
        loadProductInfoList({
            id: parameter.carouselId,
            getProductCollectionParameter,
            isShellEdit: parameter.isShellEdit,
        }),
    );
};

export const chain = [SetCustomProductsParameter, LoadCustomProducts];

const loadProductCarouselCustomProducts = createHandlerChainRunner(chain, "LoadProductCarouselCustomProducts");
export default loadProductCarouselCustomProducts;
